import React, { Component } from 'react';
import styled from '@emotion/styled';
import { DirectUploadProvider } from 'react-activestorage-provider';

import ReactSpinner from 'react-spinjs-fix';
import { DEFAULT_OPTS as SPINNER_OPTIONS } from 'views/anyguide/helpers/spinner';

import { Theme, HFlex, Text } from '../styles';

const size = '200px';

const Container = styled('div')`
  width: ${size};
  height: ${size};
  align-self: flex-start;
  position: relative;
`;
const Hidden = styled('div')`
  display: none;
`;

const Uploader = styled(HFlex)`
  justify-content: center;
  position: relative;
  height: ${size};
  width: ${size};
  border: 1px dashed ${Theme.colors.lightBorder};
`;

const Image = styled('div')`
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  height: 150px;
  width: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
`;

const ImageOverlay = styled(HFlex)`
  justify-content: center;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;

  /* Styling + positioning of the af-edit icon */
  i {
    position: absolute;
    bottom: 5px;
    right: 10px;
    color: ${Theme.colors.lightText};
  }
`;

class ImageUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      uploadedFile: null,
      uploadProgress: 100,
    };
  }

  generateUploadPreview = (upload) => {
    const uploadedFile = URL.createObjectURL(upload);
    this.setState({ uploadedFile });
  };

  injectProvider = () => {
    const { uploading, uploadProgress } = this.state;
    const { form } = this.props;

    return (
      <DirectUploadProvider
        origin={{}}
        onSuccess={(resource) => {
          // Set form values + unset uploading state
          form.setFieldValue('avatar', resource[0]);
          this.setState({ uploading: false });
        }}
        render={({ handleUpload, uploads, ready }) => {
          // Update upload progress as necessary
          if (uploading && uploads.length > 0 && uploads[0]) {
            const { state, progress } = uploads[0];
            if (state === 'uploading' && progress !== uploadProgress) {
              this.setState({ uploadProgress: progress });
              form.setFieldValue('avatarProgress', progress);
            }
          }

          return (
            <Hidden>
              <input
                id="file"
                type="file"
                name="file"
                disabled={!ready}
                onChange={(e) => {
                  // Generate preview + set uploading state
                  this.generateUploadPreview(e.currentTarget.files[0]);
                  this.setState({ uploading: true, uploadProgress: 0 });
                  form.setFieldValue('avatarProgress', 0);

                  // Upload to server
                  handleUpload(e.currentTarget.files);
                }}
              />
            </Hidden>
          );
        }}
      />
    );
  };

  renderUploader = () => {
    const { uploading, uploadedFile } = this.state;
    const { imageUrl, color } = this.props;

    // Spinner for uploading state
    let spinner = null;
    if (uploading) {
      spinner = <ReactSpinner config={SPINNER_OPTIONS} />;
    }

    // Overlay logic for edit icon / plus icon
    let image = null;
    let overlay = (
      <Text
        fontSize={72}
        color={color || Theme.colors.linksDesignElementsBaseColor}
      >
        +
      </Text>
    );

    if (uploadedFile || imageUrl) {
      image = <Image image={uploadedFile || imageUrl} />;
      overlay = <i className="af-edit" />;
    }

    return (
      <label htmlFor="file">
        <Uploader>
          {image}
          <ImageOverlay>
            {spinner}
            {overlay}
          </ImageOverlay>
        </Uploader>
      </label>
    );
  };

  render() {
    return (
      <Container>
        {this.injectProvider()}
        {this.renderUploader()}
      </Container>
    );
  }
}

export default ImageUploader;
